// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 47386, offsets 191546:191624. Structure and names inferred from code, not screenshots.

import * as SiteState from "../state/siteStore.js";
const inviteStore = SiteState.inviteStore;
export { inviteStore };
